// App.js
import React, { useEffect } from 'react';
import PdfViewer from './Pages/PdfViewer.js';

function App() {
  const params = new URLSearchParams(window.location.search);

  const restaurantName = params.get('restaurantName') || '';
  const restaurantId = params.get('restaurantId') || '';
  const slot = params.get('slot') || '1'; // Get slot parameter, default to '1'

  // Set globally for easy access
  window.restaurantName = restaurantName;
  window.restaurantId = restaurantId;
  window.slot = slot;

  // Set the document title globally
  useEffect(() => {
    document.title = `${restaurantName && restaurantName.trim() !== "" ? restaurantName : "dit restaurant"}`;
  }, [restaurantName]);

  return (
    <>
      <PdfViewer restaurantId={restaurantId} slot={slot} />
    </>
  );
}

export default App;